import { useState } from "react";
import { EspecialistaAdminUpdate } from "./EspecialistaAdminUpdate";
import { EspecialistaAdminDelete } from "./EspecialistaAdminDelete";
import {
  Link,
  useNavigate,
  useParams,
  useLoaderData,
} from "react-router-dom";
import Select from "react-select";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import es from 'react-phone-input-2/lang/es.json'

export function EspecialistaAdminEdit() {
  const especialista = useLoaderData();
  const navigate = useNavigate();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [firstName, setFirstName] = useState(especialista?.first_name);
  const [lastName, setLastName] = useState(especialista?.last_name);
  const [direccion, setDireccion] = useState(especialista?.meta?.direccion);
  const [direccionNum, setDireccionNum] = useState(especialista?.meta?.direccion_num);
  const [direccionPiso, setDireccionPiso] = useState(especialista?.meta?.direccion_piso);
  const [direccionCiudad, setDireccionCiudad] = useState(especialista?.meta?.direccion_ciudad);
  const [direccionProvincia, setDireccionProvincia] = useState(especialista?.meta?.direccion_provincia);
  const [direccionCp, setDireccionCp] = useState(especialista?.meta?.direccion_cp);
  const [email, setEmail] = useState(especialista?.email);
  const [telefono, setTelefono] = useState(especialista?.meta?.telefono);
  const [dni, setDni] = useState(especialista?.meta?.dni);
  const username = especialista?.username;
  const [especialidad, setEspecialidad] = useState(especialista?.meta?.especialidad);
  const [colegiado, setColegiado] = useState(especialista?.meta?.colegiado);
  const [telefonoSecundario, setTelefonoSecundario] = useState(especialista.meta?.telefono_familiar);
  const [estadoUsuario, setEstadoUsuario] = useState(especialista.meta?.estado || 'activo');

  let especialistaId = especialista.id;

  // Load Espacialidades Options
  const especialidadOpt = [
    { value: 'medicina', label: 'Medicina' },
    { value: 'psicologia', label: 'Psicología' },
    { value: 'psicologia-hospital', label: 'Psicólogo Hospital' },
    { value: 'nutricion', label: 'Nutrición' },
    { value: 'entrenamiento', label: 'Entrenamiento' },
    { value: 'mindfulness', label: 'Mindfulness' }
  ];

  const submitEspecialistaAdmin = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      firstName,
      lastName,
      direccion,
      direccionNum,
      direccionPiso,
      direccionCiudad,
      direccionProvincia,
      direccionCp,
      email,
      telefono,
      telefonoSecundario,
      dni,
      username,
      especialidad,
      colegiado,
      estadoUsuario
    );
    try {
      await EspecialistaAdminUpdate(
        firstName,
        lastName,
        direccion,
        direccionNum,
        direccionPiso,
        direccionCiudad,
        direccionProvincia,
        direccionCp,
        email,
        telefono,
        telefonoSecundario,
        dni,
        username,
        especialidad,
        colegiado,
        estadoUsuario,
        especialistaId
      ).then(
        (val) => {
          navigate(`../especialistas/${especialistaId}`);
          console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteUser = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await EspecialistaAdminDelete(
        especialistaId
      ).then(
        (val) => {
          navigate(`../especialistas`);
          console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formUpdatelement' onSubmit={submitEspecialistaAdmin}>
        <fieldset id="disabledContainer">
        <h3>Actualizar Especialista</h3>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='firstName'>Nombre</label>
              <div className='control'>
                <input
                  className='input'
                  id='firstName'
                  required
                  type='text'
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='lastName'>Apellidos</label>
              <div className='control'>
                <input
                  className='input'
                  id='lastName'
                  required
                  type='text'
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='email'>Email</label>
              <div className='control'>
                <input
                  className='input'
                  id='email'
                  required
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='dni'>DNI</label>
              <div className='control'>
                <input
                  className='input'
                  id='dni'
                  required
                  type='text'
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
              </div>
            </div>
          </div>


          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='telefono'>Teléfono Móvil</label>
              <div className='control'>
                <PhoneInput
                  inputProps={{
                    className: 'input',
                    name: 'telefono',
                    required: true,
                    id: 'telefono'
                  }}
                  placeholder='+34 658 309 174'
                  localization={es}
                  value={telefono}
                  country={'es'}
                  onChange={(value) => setTelefono( value )}
                />
              </div>
            </div>
            <div className='field'>
                <label htmlFor='telefonoSecundario'>
                  Número de teléfono secundario
                </label>
                <div className='control'>
                  <PhoneInput
                    inputProps={{
                      className: "input",
                      name: "telefonoSecundario",
                      id: "telefonoSecundario",
                    }}
                    placeholder='+34 658 309 174'
                    localization={es}
                    value={telefonoSecundario}
                    country={"es"}
                    onChange={(value) => setTelefonoSecundario(value)}
                  />
                </div>
              </div>
          </div>
          

          <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='direccion'>Dirección</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccion'
                    type='text'
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionNum'>Número</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionNum'
                    type='text'
                    value={direccionNum}
                    onChange={(e) => setDireccionNum(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionPiso'>Piso</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionPiso'
                    type='text'
                    value={direccionPiso}
                    onChange={(e) => setDireccionPiso(e.target.value)}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='direccionCiudad'>Población</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionCiudad'
                    type='text'
                    value={direccionCiudad}
                    onChange={(e) => setDireccionCiudad(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionProvincia'>Provincia</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionProvincia'
                    type='text'
                    value={direccionProvincia}
                    onChange={(e) => setDireccionProvincia(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionCp'>Código postal</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionCp'
                    type='text'
                    value={direccionCp}
                    onChange={(e) => setDireccionCp(e.target.value)}
                  />
                </div>
              </div>
            </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>Nombre de usuario</label>
              <div className='control'>
                <input
                  className='input'
                  disabled
                  readOnly
                  id='username'
                  type='text'
                  value={username}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='especialidad'>Especialidad</label>
              <div className='control'>
              <Select
                          isMulti
                          id='especialidad'
                          name='especialidad'
                          options={especialidadOpt}
                          className='basic-multi-select'
                          classNamePrefix='select'
                          placeholder='Seleccionar especialidad'
                          onChange={setEspecialidad}
                          value={especialidad}
                        />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='colegiado'>Número de Colegiado</label>
              <div className='control'>
                <input
                  className='input'
                  id='colegiado'
                  type='text'
                  value={colegiado}
                  onChange={(e) => setColegiado(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className="field">
              <label htmlFor="estadoUsuario">Estado del usuario</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="estadoUsuario"
                    required
                    name="estadoUsuario"
                    value={estadoUsuario}
                    onChange={(e) => setEstadoUsuario(e.target.value)}
                  >
                    <option disabled value="">-- Selecciona una opción --</option>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </fieldset>
        </form>
      </div>
      <div id='actions'>
        <button 
        className="button is-link" 
        id="saveButton" 
        form="formUpdatelement" 
        type="submit"
                    disabled={isCreatingButton}
        >
        {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        <Link className="button is-link is-light" to={`../especialistas/${especialistaId}`}>Cancelar</Link>
        <button 
        className="button is-danger" 
        id="deleteButton" 
        onClick={deleteUser}
        disabled={isDeletingButton}
        >
        {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
      </div>
    </>
  );
}
